import { feature, merge } from 'topojson-client';
import { geoMercator, geoPath, geoArea } from 'd3-geo';
import topo from '../../data/uk-postcode-areas.json';

let cache = null;

// UK silhouette + one point per postcode area, projected into a w×h box.
export function getUKMap(w = 700, h = 900) {
  if (cache) return cache;
  const obj = topo.objects['uk-postcode-area'];
  const fc = feature(topo, obj);
  // keep the largest geometry per id (data has a few degenerate duplicates)
  const byId = new Map();
  fc.features.forEach((f) => {
    const prev = byId.get(f.id);
    if (!prev || geoArea(f) > geoArea(prev)) byId.set(f.id, f);
  });
  const features = [...byId.values()];
  const clean = { type: 'FeatureCollection', features };
  const proj = geoMercator().fitSize([w, h], clean);
  const path = geoPath(proj);
  const outline = merge(topo, obj.geometries);
  const pins = features
    .map((f) => { const c = path.centroid(f); return { id: f.id, x: c[0], y: c[1] }; })
    .filter((p) => Number.isFinite(p.x) && Number.isFinite(p.y));
  cache = { d: path(outline), pins, w, h };
  return cache;
}
